module.exports = __webpack_public_path__ + "static/media/725CameronMadisonAlexanderBlvdNW_2018-07-09_136.f11c719d.jpg";